// extracted by mini-css-extract-plugin
module.exports = {"install-guide":"install_guide_install-guide__diOIz","title":"install_guide_title__KpPsF","btn":"install_guide_btn__pcZLB"};